module.exports = __webpack_public_path__ + "static/media/OPTIMA.db2c6e63.TTF";